import React, { useEffect, useContext, useState } from "react";
import "./../../../../font.css";
import { CircularProgress } from "@mui/material";
import { Translate } from "react-i18nify";
import * as Icons from "@mui/icons-material";

import SocketIOContext from "./../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
// import SocketIOContext from "../../../contexts/Kiosk/SocketProvider/SocketIOContext";

let env = require("./../../../../env");

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
// function StepIcon({ themePath, imgUrl, DefaultIcon, cssSizeString, iconName }) {
//   const { getKioskTheme } = useContext(SocketIOContext);

//   const [loading, setLoading] = useState(true);
//   const kioskTheme = getKioskTheme();

//   if (iconName) {
//     const IconComponent = Icons[iconName];

//     return <IconComponent style={{ fontSize: cssSizeString }} />;
//   }

//   if (!kioskTheme[themePath]) {
//     return <DefaultIcon style={{ fontSize: cssSizeString }} />;
//   }

//   return (
//     <img
//       src={
//         env.REACT_APP_API_ENDPOINT +
//         "/kiosk/getImage/" +
//         imgUrl +
//         "?t=" +
//         kioskTheme.lastUpdatedImgETag
//       }
//       // objectFit="contain"
//       style={{
//         width: cssSizeString,
//         height: cssSizeString,
//         objectFit: "contain"
//       }}
//       alt="Step Icon"
//     />
//   );
// }

export function StepIcon({ DefaultIcon, cssSizeString, iconName }) {
  //const { getKioskTheme } = useContext(SocketIOContext);

  //const [loading, setLoading] = useState(true);
  //const kioskTheme = getKioskTheme();

  // if (!iconName) {
  //   const IconComponent = Icons[DefaultIcon];
  //   if (!IconComponent) {
  //     console.warn(`Icon "${DefaultIcon}" not found in Icons object`);
  //     return <div>DefaultIconNotFound</div>; // or a fallback icon
  //   }
  //   return <IconComponent style={{ fontSize: cssSizeString }} />;
  // }

  // const IconComponent = Icons[iconName];
  // if (!IconComponent) {
  //   console.warn(`Icon "${DefaultIcon}" not found in Icons object`);
  //   return <div>IconNotFound</div>; // or a fallback icon
  // }
  // return <IconComponent style={{ fontSize: cssSizeString }} />;

  const DefaultIconComponent = Icons[DefaultIcon];
  const IconComponent = iconName ? Icons[iconName] : null;

  // console.log("[DEBUG] StepIcon defaultIconComponent", !DefaultIconComponent);
  // console.log("[DEBUG] StepIcon iconName", iconName, !iconName);
  // console.log("[DEBUG] StepIcon IconComponent", !IconComponent);

  if (!iconName || !IconComponent) {
    if (!DefaultIconComponent) {
      console.warn(`Icon "${DefaultIcon}" not found in Icons object`);
      return <div>DefaultIconNotFound</div>; // or a fallback icon
    }
    //    console.log("[DEBUG] StepIcon Returning Default Icon");
    return <DefaultIconComponent style={{ fontSize: cssSizeString }} />;
  }

  //  console.log("[DEBUG] StepIcon Returning Theme Icon");
  return <IconComponent style={{ fontSize: cssSizeString }} />;
}

export function isValidIconName({ iconName }) {
  const IconComponent = iconName ? Icons[iconName] : null;

  if (!IconComponent) {
    return false;
  }

  return true;
}

//export StepIcon;
